import type { WorkoutExerciseLog, WorkoutSetLog } from '../../api/workoutApi'

export const MAX_SET_LOGS = 15

export type LogActual = {
  comment: string
  setLogs: WorkoutSetLog[]
}

export type LogActuals = Record<number, LogActual>

const emptySet = (): WorkoutSetLog => ({ weight: '', reps: '' })

export function logActualFromExercise(ex: WorkoutExerciseLog): LogActual {
  const sets = (ex.setLogs ?? []).map((s) => ({
    weight: s.weight ?? '',
    reps: s.reps ?? '',
  }))
  const plannedCount = Math.min(Math.max(ex.plannedSets ?? 1, 1), MAX_SET_LOGS)
  return {
    comment: ex.comment ?? '',
    setLogs: sets.length > 0
      ? sets
      : Array.from({ length: plannedCount }, emptySet),
  }
}

export function normalizeSetLogsForSave(setLogs: WorkoutSetLog[] | undefined | null): WorkoutSetLog[] {
  const mapped = (setLogs ?? [])
    .slice(0, MAX_SET_LOGS)
    .map((s) => ({
      weight: (s.weight ?? '').trim() || null,
      reps: (s.reps ?? '').trim() || null,
    }))
  let lastFilled = mapped.length - 1
  while (lastFilled >= 0 && !mapped[lastFilled].weight && !mapped[lastFilled].reps) {
    lastFilled -= 1
  }
  return lastFilled < 0 ? [] : mapped.slice(0, lastFilled + 1)
}

export function setLogsEqual(
  a: WorkoutSetLog[] | undefined | null,
  b: WorkoutSetLog[] | undefined | null,
): boolean {
  const left = normalizeSetLogsForSave(a)
  const right = normalizeSetLogsForSave(b)
  if (left.length !== right.length) return false
  return left.every((s, i) => s.weight === right[i].weight && s.reps === right[i].reps)
}

export function isLogActualDirty(ex: WorkoutExerciseLog, local: LogActual | undefined): boolean {
  const row = local ?? logActualFromExercise(ex)
  const savedComment = (ex.comment ?? '').trim()
  const comment = (row.comment ?? '').trim()
  return comment !== savedComment || !setLogsEqual(row.setLogs, ex.setLogs)
}
